import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"

import StripeCheckoutForm from "./StripeCheckoutForm"

type StripeProps = {
  logo?: () => JSX.Element
  logoSrc?: string
  open: boolean
  itemName: string
  price: string
  clientSecret: string
  handleClose: () => void
  redirectURL: string
  paymentKey: string
  isUpdatePaymentMethod?: boolean
}

const init = ({ paymentKey, clientSecret, ...props }: StripeProps) => {
  if (!paymentKey) {
    throw new Error("STRIPE PAYMENT KEY is missing in environment")
  }
  const stripePromise = loadStripe(paymentKey)

  return (
    <Elements
      options={{
        clientSecret,
        appearance: {
          theme: "stripe",
        },
      }}
      stripe={stripePromise}
    >
      <StripeCheckoutForm {...props} />
    </Elements>
  )
}

export { init }
